import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiFormGroupStyles = {
    styleOverrides: {
        root: {
            '&[role="radiogroup"]': {
                backgroundColor: Palette.gray.gray50,
                border: `2px solid ${Palette.gray.gray100}`,
                borderRadius: '12px',
                width: '100%',
                '& .MuiFormControlLabel-root': {
                    padding: '12px 14px',
                    position: 'relative',
                    margin: '0',
                    flex: '1',
                    '& + .MuiFormControlLabel-root': {
                        borderLeft: `2px solid ${Palette.gray.gray100}`,
                    },
                    '& .MuiRadio-root': {
                        padding: '0 7px 0 0',
                        '& + .MuiTypography-root.MuiTypography-body1': {
                            fontSize: '14px',
                        },
                        '&.Mui-checked': {
                            position: 'static',
                            '& .MuiSvgIcon-root': {
                                '& + .MuiSvgIcon-root': {
                                    '& path': {
                                        fill: Palette.gray.gray800,
                                    },
                                },
                            },
                            '&::before': {
                                content: '" "',
                                width: '100%',
                                height: '100%',
                                backgroundColor: Palette.white,
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '0',
                                boxShadow: Palette.boxShadow.elevation2,
                            },
                            '& + .MuiFormControlLabel-label': {
                                position: 'relative',
                                zIndex: 1,
                            },
                        },
                    },
                    '&:first-of-type': {
                        '& .MuiRadio-root': {
                            '&.Mui-checked': {
                                '&::before': {
                                    borderRadius: '12px 0 0 12px',
                                },
                            },
                        },
                    },
                    '&:last-child': {
                        '& .MuiRadio-root': {
                            '&.Mui-checked': {
                                '&::before': {
                                    borderRadius: '0 12px 12px 0',
                                },
                            },
                        },
                    },
                },
            },
        },
    },
};
